import { Button, Card, Grid } from '@mui/material';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import { Stack } from '@mui/system';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Formik, connect } from 'formik';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import CustomAutoComplete from '../../../components/admin/common/AutoComplete/CustomAutoComplete';
import { showCustomComponentNotification, showErrorNotification, showSuccessNotification, showWarningNotification, } from '../../../components/admin/common/NotiService';
import OZDialog from "../../../components/admin/common/OZDialog";
import OZInput from '../../../components/admin/common/OZInput';
import LoadingScreen from '../../../components/admin/common/OZLoadingScreen/OZLoadingScreen';
import OZSelect from '../../../components/admin/common/OZSelect';
import OZTable from '../../../components/OZTable/OZTable';
import { useCheckBooleanSetting } from '../../../contexts/SettingsContext';
import { adminService } from '../../../services/admin-services';
import { enqueueCampaignAsyncAction, getCampaignDispositonsDropdown, getReasonsDropdown, getagentsInActiveDropdown, getskillsDropdown } from '../../../services/api-service';
import { prepareApiFilterParams } from '../../../utils/util';

const columns = [
    { name: 'Phone No', key: 'PhoneNumber' },
    { name: 'Name', key: 'LeadName' },
    { name: 'Dial Status', key: 'DialStatus' },
    { name: 'Disposition', key: 'Disposition' },
    { name: 'Data Added on', key: 'DateCreated' },
];

const EMPTY_CAMPAIGN_DATE = "0000-00-00 00:00:00";
const OUTBOUND_REPORT_TYPE = 1;

const ResetCampaignForm = (props) => {
    const [openDownloadDataGrid, setDownloadDataGrid] = useState(false)
    const [openResetCampaignDataform, setResetCampaignDataform] = useState(true);
    const [rowData, setRowData] = useState([]);
    const [reasonsList, setReasonsList] = useState([]);
    const [dispositonsList, setDispositonsList] = useState([]);
    const [agentList, setAgentList] = useState([]);
    const [skillList, setSkillList] = useState([]);
    const [finalData, setFinalData] = useState(false);
    const [disabledByLoading, setDisabledByLoading] = useState(false);
    const [newLoading, setNewLoading] = useState(false);
    const [controller, setController] = useState({ page: 1, fromLimit: 0, toLimit: 25, rowsPerPage: 25 });
    const [totalPages, setTotalPages] = useState(0);
    const [totalRows, setTotalRows] = useState();
    const ivrDialerV2Enabled = useCheckBooleanSetting("IVR_DIALER_V2");
    const asyncCampaignResetDelete = props?.asyncCampaignResetDelete || false;
    const navigate = useNavigate();

    const getResponseStatus = (resp) => `${resp?.status || resp?.Status || ''}`.toLowerCase();
    const getResponseMessage = (resp, fallback = '') => `${resp?.message || resp?.Message || fallback}`;

    const shouldUseAsyncOutboundAction = () => {
        const campaignType = `${props?.campaignData?.campaignType || ''}`.toUpperCase();
        if (asyncCampaignResetDelete && campaignType === 'IVR') {
            return !ivrDialerV2Enabled;
        }
        return asyncCampaignResetDelete;
    }


    const normalizeDateForAsyncPayload = (value) => {
        try {
            if (!value || `${value}`.trim() === '') {
                return EMPTY_CAMPAIGN_DATE;
            }
        } catch (e) {
            console.error(e)
        }
        return value;
    }

    const ASYNC_ACTION_FILE_NAMES = {
        delete_campaign_data: 'DeleteCampaignData',
        reset_campaign_data: 'ResetCampaignData',
    };

    const buildAsyncPayload = (data, reportName, campaignId) => {
        const [skills, agents] = [prepareApiFilterParams(data?.skill, ['skillId', 'id']), prepareApiFilterParams(data?.agent, ['id'])];
        return {
            fromDate: normalizeDateForAsyncPayload(data?.fromDate),
            toDate: normalizeDateForAsyncPayload(data?.toDate),
            status: data?.status || 'All',
            dialStatus: data?.dialStatus || 'All',
            disposition: data?.disposition || 'All',
            skillId: skills === "0_all" ? 0 : skills,
            agentId: agents === "0_all" ? 0 : agents,
            priority: data?.priority || '',
            dateSortBy: data?.dateSortBy || '',
            returnCount: '0',
            reportName,
            fileName: ASYNC_ACTION_FILE_NAMES[reportName] || reportName,
            export_format: 'csv',
            compress: false,
            type: OUTBOUND_REPORT_TYPE,
            campaignId
        }
    }

    useEffect(() => {
        getReasonsListDropDown(props?.ID)
        getDispositonsListDropDown(props?.ID)
        getSkillListDropDown()
        getAgentListDropDown()
    }, []);

    useEffect(() => {
        getCampaignRegenerateData(finalData, props?.ID, controller);
    }, [controller]);

    const dateFormatterResetCampaign = (value) => {
        const date = new Date(value);
        const options = { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
        return date.toLocaleString("en-GB", options);
    }

    const handlePageChange = (newPage) => {
        if (newPage === 1) {
            setController({
                ...controller,
                page: 1,
                fromLimit: 0,
                toLimit: (controller.toLimit)
            })
        }
        else if (newPage > 1) {
            setController({
                ...controller,
                page: newPage,
                fromLimit: (controller.toLimit * (newPage - 1)),
                toLimit: controller.toLimit
            })
        }
    };

    const handleChangeRowsPerPage = (event) => {
        setController({
            ...controller,
            page: 1,
            toLimit: parseInt(event.target.value, 10),
            rowsPerPage: parseInt(event.target.value, 10),
            fromLimit: 0
        });
    };

    async function getReasonsListDropDown(id) {
        try {
            getReasonsDropdown(id).then(resp => {
                // setReasonsList(resp.Data);
                const updatedData = resp?.Data?.length > 0 ? resp?.Data.map((item, index) => ({
                    ...item,
                    id: index + 100
                })) : [{ id: "0_all", dialStatus: "All" }];
                setReasonsList(updatedData);
            }).catch(e => {
                setReasonsList([]);
            })
        }
        catch (e) {
            showErrorNotification(JSON.stringify(e));
        }
    };
    async function getDispositonsListDropDown(id) {
        try {
            getCampaignDispositonsDropdown(id).then(resp => {
                // setDispositonsList(resp.Data);
                const updatedData = resp?.Data?.length > 0 ? resp.Data.map((item, index) => ({
                    ...item,
                    disposition: item.reason,
                    id: index + 100
                })) : [{ id: "0_all", disposition: "All" }];
                setDispositonsList(updatedData);
            }).catch(e => {
                setDispositonsList([]);
            })
        }
        catch (e) {
            showErrorNotification(JSON.stringify(e));
        }
    };

    async function getAgentListDropDown() {
        try {
            getagentsInActiveDropdown().then(resp => {
                setAgentList(resp);
            }).catch(e => {
                setAgentList([]);
            })
        }
        catch (e) {
            showErrorNotification(JSON.stringify(e));
        }
    };

    async function getSkillListDropDown() {
        try {
            getskillsDropdown().then(resp => {
                setSkillList(resp.Data);
            }).catch(e => {
                setSkillList([]);
            })
        }
        catch (e) {
            showErrorNotification(JSON.stringify(e));
        }
    };

    const validationSchema = useMemo(() => (yup.object({
        status: yup
            .object()
            .nullable()
            .required("Status is required."),
        // reason: yup
        //     .string("Reason is required.")
        //     .nullable()
        //     .required("Reason is required."),
        dialStatus: yup
            .array()
            .min(1, "At least one dial status is required.")
            .required("Dial status is required."),
        disposition: yup
            .array()
            .min(1, "At least one disposition is required.")
            .required("Disposition is required."),
        skill: yup
            .array()
            .when('dialMethod', {
                is: type => type === 'Skillwise',
                then: yup
                    .array()
                    .nullable()
                    .min(1, "Skill field must have at least 1 item.")
                    .required("Skill is required."),
                otherwise: yup.array().notRequired().nullable()
            }),
        agent: yup
            .array()
            .when('dialMethod', {
                is: type => type === 'Agentwise',
                then: yup
                    .array()
                    .nullable()
                    .min(1, "Agent field must have at least 1 item.")
                    .required("Agent is required."),
                otherwise: yup.array().notRequired().nullable()
            }),
    })), []);



    const closeResetCampaignDataform = () => {
        localStorage.removeItem("ResetForm");
        setResetCampaignDataform(false);
        props.onClose();
    }

    function closeDataGrid() {
        setDownloadDataGrid(false)
    }

    async function getCampaignRegenerateData(body, id, updatedController = null) { //api service
        setNewLoading(true);
        try {
            const { fromLimit, toLimit } = updatedController || controller;
            let bodyParams = {
                ...body,
                "dateSortBy": "",
                "returnCount": "1",
                "fromLimit": 0,
                "toLimit": 0
            }
            const resp = await adminService({ urlParams: `campaignResetDataV1/${id}?action=preview`, bodyParams, method: 'POST' })
            if (resp.Status === "Success" && resp.Message.length > 0) {
                let totalRows = resp.Message[0].RecordCount;
                bodyParams.returnCount = "0";
                bodyParams.toLimit = toLimit;
                bodyParams.fromLimit = fromLimit;
                setTotalRows(totalRows);
                if (totalRows > 0) {
                    const response = await adminService({
                        urlParams: `campaignResetDataV1/${id}?action=preview`, bodyParams, method: 'POST'
                    });
                    if (response.Status === "Success" && response.Message.length > 0) {
                        setTotalPages(Math.ceil(totalRows / (controller.toLimit)));
                        setRowData(response.Message.map(item => ({
                            ...item,
                            DateCreated: dateFormatterResetCampaign(item.DateCreated)
                        })));
                    } else {
                        showErrorNotification(typeof resp.Message === 'string' ? resp.Message : "Unable to get Reset Campaign data");
                    }
                } else {
                    setRowData([]);
                    setTotalRows(0);
                }
            } else {
                showErrorNotification(typeof resp.Message === 'string' ? resp.Message : "Unable to get Reset Campaign data");
            }
        }
        catch (e) {
            setNewLoading(false);
            setRowData([]);
            setTotalRows(0);
        } finally {
            setNewLoading(false);
        }
    }

    const notifySuccess = async (message) => {
        showCustomComponentNotification({
            component: (
                <label style={{ fontSize: '14px', fontWeight: '400', color: '#212121' }}>
                    {message}
                    <br />
                    <span style={{ textDecoration: 'none', cursor: 'pointer', color: '#3d8bf8', fontSize: '12px', }}
                        onClick={() => { navigate('/admin/reportStatusAdmin'); }}
                    >
                        Click here to Navigate to "Report Status" Page
                    </span>
                </label >
            ),
            variant: 'success',
        });
        if (typeof props?.onCampaignStatusRefresh === 'function') {
            await props.onCampaignStatusRefresh();
        }
        closeResetCampaignDataform();
    }

    async function deleteCampaignDataButton(data, id) {
        setNewLoading(true);
        const newData = {
            ...data,
            "dateSortBy": "",
            "fromLimit": 0,
            "toLimit": 0,
            "returnCount": "0"
        }
        try {
            if (shouldUseAsyncOutboundAction()) {
                try {
                    const response = await enqueueCampaignAsyncAction(buildAsyncPayload(newData, 'delete_campaign_data', id));
                    const status = getResponseStatus(response);
                    if (response?.job_id || status === 'queued' || status === 'success' || status === 'in_progress') {
                        await notifySuccess(getResponseMessage("", `${props?.props?.campaignName || 'Campaign'} delete request queued successfully with job id ${response?.job_id || ''}`));
                    } else {
                        showErrorNotification(getResponseMessage("", 'Unable to queue delete request'));
                    }
                } catch (e) {
                    showErrorNotification('Unable to queue delete request');
                } finally {
                    setNewLoading(false);
                }
                return;
            }
            const resp = await adminService({ urlParams: `campaignResetDataV1/${id}?action=delete`, bodyParams: newData, method: 'POST' })
            if (resp.Status === "Success") {
                if (resp.Message && typeof resp.Message === 'string') {
                    showSuccessNotification(`${props.props.campaignName} ${resp.Message}`);
                }
                closeResetCampaignDataform();
            }
            else {
                if (resp.Message && typeof resp.Message === 'string') {
                    showErrorNotification(resp.Message);
                }
            }
        }
        catch (e) {
            setNewLoading(false);
            console.error("error", e);
        } finally {
            setNewLoading(false);
        }
    }

    async function resetCampaignDataButton(data, id) {
        setNewLoading(true);
        try {
            const newData = {
                ...data,
                "dateSortBy": "",
                "fromLimit": 0,
                "toLimit": 0,
                "returnCount": "0"
            }
            if (shouldUseAsyncOutboundAction()) {
                try {
                    const response = await enqueueCampaignAsyncAction(buildAsyncPayload(newData, 'reset_campaign_data', id));
                    const status = getResponseStatus(response);
                    if (response?.job_id || status === 'queued' || status === 'success' || status === 'in_progress') {
                        await notifySuccess(getResponseMessage("", `${props?.props?.campaignName || 'Campaign'} reset request queued successfully with job id ${response?.job_id || ''}`));
                    } else {
                        showErrorNotification(getResponseMessage("", 'Unable to queue reset request'));
                    }
                } catch (e) {
                    showErrorNotification('Unable to queue reset request');
                } finally {
                    setNewLoading(false);
                }
                return;
            }
            const resp = await adminService({ urlParams: `campaignResetDataV1/${id}?action=reset`, bodyParams: newData, method: 'POST' })
            if (resp.Status === "Success") {
                if (resp.Message && typeof resp.Message === 'string') {
                    showSuccessNotification(`${props.props.campaignName} ${resp.Message}`);
                }
                closeResetCampaignDataform();
            } else {
                if (resp.Message && typeof resp.Message === 'string') {
                    showErrorNotification(resp.Message);
                }
            }
        }
        catch (e) {
            console.log("error", e);
            showErrorNotification("Failed to reset Reset Campaign data");
        } finally {
            setNewLoading(false);
        }
    }

    const formButtonStyle = useMemo(
        () => ({
            borderRadius: '8px',
            fontWeight: '400',
            fontSize: '14px',
        }),
        []
    );

    const DataForm = (data) => {
        if (props?.disabled || data?.data === {}) {
            setDisabledByLoading(true);
        } else {
            setDisabledByLoading(false);
        }
        let initData = JSON.parse(localStorage.getItem("ResetForm")) || {
            fromDate: null,
            toDate: null,
            status: { label: 'All', value: 'All' },
            // dialStatus: "All",
            dialStatus: [{ id: "0_all", dialStatus: "All" }],
            // disposition: "All",
            disposition: [{ id: "0_all", disposition: "All" }],
            skill: [],
            agent: [],
            // reason: "All",
            priority: "",
            dialMethod: data?.data?.dialMethod,
        };

        if (!initData.status) {
            initData.status = { label: 'All', value: 'All' };
        }

        const MaterialUIPickers = connect(({ name, onChangefunction, formik }) => {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const [value, setValue] = useState(null);

            const onSelect = (newValue) => {
                setValue(newValue);
                let newFormatedValue = newValue?.format("YYYY-MM-DD HH:mm:ss");
                formik.setFieldValue(name, newFormatedValue);
            };

            return (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Stack spacing={3}>
                        <DateTimePicker
                            disableFuture
                            value={value}
                            views={["year", "month", "day", "hours", "minutes", "seconds"]}
                            onChange={onSelect}
                            inputFormat="YYYY-MM-DD HH:mm:ss"
                            renderInput={(params) => <TextField sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                    backgroundColor: '#ffff',
                                    fontSize: '14px',
                                    height: '44px',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: '1px solid #D6D6D7'
                                },
                                '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
                                    // backgroundColor: '#D6D6D7', //TODO
                                    border: '1px solid #D6D6D7'
                                }
                            }} {...params} />}
                        />
                    </Stack>
                </LocalizationProvider>
            );
        })

        const handleDelete = (values) => {
            let id = data.data.campaignId;
            deleteCampaignDataButton(finalData, id);
        }

        const handleReset = (values) => {
            let id = data.data.campaignId;
            console.log("final data", finalData)
            resetCampaignDataButton(finalData, id);
        }

        return (
            <div>
                <Formik
                    initialValues={initData}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                        let saveData = structuredClone(values);
                        localStorage.setItem("ResetForm", JSON.stringify(values));
                        if (saveData.status != null) {
                            saveData.status = saveData.status.value;
                        }
                        let id = data.data.campaignId;

                        if (!saveData.fromDate) {
                            saveData.fromDate = null;
                        }
                        if (!saveData.toDate) {
                            saveData.toDate = null;
                        }

                        if (saveData.fromDate !== null) {
                            if (saveData.toDate === null) {
                                showWarningNotification("ToDate Should not be empty");
                                return;
                            }
                        }

                        if (saveData.toDate !== null) {
                            if (saveData.fromDate === null) {
                                showWarningNotification("FromDate Should not be empty");
                                return;
                            }
                        }

                        if (saveData.toDate === "Invalid Date" || saveData.fromDate === "Invalid Date") {
                            showErrorNotification("Invalid date, Please check the date passed");
                            return;
                        }

                        if (saveData.fromDate !== null && saveData.toDate !== null) {
                            let CDate = new Date().toString();
                            let NstartDate = moment(saveData.fromDate, 'YYYY-MM-DD HH:mm:ss').toDate();
                            let NEndDate = moment(saveData.toDate, 'YYYY-MM-DD HH:mm:ss').toDate();
                            let timestampCDate = new Date(CDate).getTime();
                            let timestampNstartDate = new Date(NstartDate).getTime();
                            let timestampNEndDate = new Date(NEndDate).getTime();
                            if (timestampCDate <= timestampNstartDate) {
                                showErrorNotification("FromDate should not be greater than Current Date");
                                return
                            }
                            if (timestampCDate <= timestampNEndDate) {
                                showErrorNotification("ToDate should not be greater than Current Date");
                                return
                            }
                            if (timestampNstartDate >= timestampNEndDate) {
                                showErrorNotification("ToDate should be greater than FromData");
                                return
                            }
                        }

                        // if (saveData.fromDate !== null && saveData.toDate !== null) {
                        //     if (Date.parse(saveData.toDate) <= Date.parse(saveData.fromDate)) {
                        //         showWarningNotification("toDate should be greater than fromData");
                        //         return
                        //     }
                        // }

                        // if (saveData.status === "All") {
                        // saveData.status = "";
                        // }

                        // if (saveData.disposition === "All") {
                        //     saveData.disposition = "";
                        // }

                        // if (saveData.reason === "All") {
                        //     saveData.reason = "";
                        // }
                        // saveData.dialStatus = saveData.dialStatus.dialStatus;
                        // saveData.disposition = saveData.disposition.disposition;
                        saveData.dialStatus = saveData.dialStatus.map(item => item.dialStatus).join(",");
                        saveData.disposition = saveData.disposition.map(item => item.disposition).join(",");

                        delete saveData.dialMethod;
                        setFinalData(saveData);
                        getCampaignRegenerateData(saveData, id);
                        setDownloadDataGrid(true);
                    }}
                >
                    {(props) => (
                        <form
                            onSubmit={props.handleSubmit} id="resetCampaign-Form" className="ozcw-scrollbar" style={{
                                maxHeight: '70vh'
                            }}
                        >
                            {disabledByLoading && (
                                <div style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: '0,0,0,0.5', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
                                    <LoadingScreen />
                                </div>
                            )}
                            <div>
                                {!openDownloadDataGrid &&
                                    <Grid container={true} spacing="24px" marginTop={"5px"}>
                                        <Grid item xs={6}>
                                            <label style={{ fontWeight: 400, fontSize: "12px" }}>From Date</label>
                                            <MaterialUIPickers name="fromDate" />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <label style={{ fontWeight: 400, fontSize: "12px" }}>To Date</label>
                                            <MaterialUIPickers name="toDate" />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <OZSelect
                                                name="status"
                                                label="Status*"
                                                placeholder={"Select"}
                                                optionLabel={'label'}
                                                options={[
                                                    { label: 'All', value: 'All' },
                                                    { label: 'Fail', value: 'Fail' },
                                                    { label: 'Success', value: 'Success' },
                                                    { label: 'Pending', value: 'Pending' },
                                                    // { label: 'Other', value: 'Other' },
                                                    { label: 'Expired', value: 'Expired' },
                                                    { label: 'Day Limit Reached', value: 'DayLimitReached' },
                                                    { label: 'Fresh Lead', value: 'FreshLead' },
                                                    { label: 'Sent', value: 'sent' }
                                                ]}
                                            />
                                        </Grid>
                                        <Grid item xs={6} >
                                            <CustomAutoComplete
                                                mode='Add'
                                                name="dialStatus"
                                                limitTags={2}
                                                placeholder={"Please Select"}
                                                Datas={reasonsList}
                                                labelHeader='Reason *'
                                                optionLabelName='dialStatus'
                                                showCheckBox={true}
                                                multiple={true}
                                                showAvatar={true}
                                                showAvatarInChip
                                                showAllOption="true"
                                                popupIcon={null}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <CustomAutoComplete
                                                mode='Add'
                                                name="disposition"
                                                limitTags={2}
                                                placeholder={"Please Select"}
                                                Datas={dispositonsList}
                                                labelHeader='Disposition *'
                                                optionLabelName='disposition'
                                                showCheckBox={true}
                                                multiple={true}
                                                showAvatar={true}
                                                showAvatarInChip
                                                showAllOption="true"
                                                popupIcon={null}
                                            />
                                        </Grid>
                                        <Grid item xs={6} >
                                            <OZInput
                                                name="priority"
                                                label="Priority"
                                                placeholder="Priority"
                                            />
                                        </Grid>

                                        {data?.data?.dialMethod === "Agentwise" && (
                                            <Grid item xs={6}>
                                                <CustomAutoComplete
                                                    mode='Add'
                                                    name="agent"
                                                    limitTags={2}
                                                    labelHeader='Agent *'
                                                    placeholder={"Select"}
                                                    Datas={agentList}
                                                    optionLabelName='agentId'
                                                    optionId='agentId'
                                                    showCheckBox={true}
                                                    multiple={true}
                                                    showAllOption="true"
                                                    showselectall="true"
                                                    popupIcon={null}
                                                />
                                            </Grid>
                                        )}

                                        {data?.data?.dialMethod === "Skillwise" && (
                                            <Grid item xs={6}>
                                                <CustomAutoComplete
                                                    mode='Add'
                                                    name="skill"
                                                    limitTags={2}
                                                    labelHeader='Skill *'
                                                    placeholder={"Select"}
                                                    Datas={skillList}
                                                    optionLabelName='skillName'
                                                    showCheckBox={true}
                                                    multiple={true}
                                                    showselectall="true"
                                                    showAllOption="true"
                                                    popupIcon={null}
                                                />
                                            </Grid>
                                        )}

                                        <Grid container spacing={2} direction={'row'} flexGrow={1} flex sx={{ marginTop: 5 }} justifyContent='end'>
                                            <Grid item>
                                                <Button style={formButtonStyle} onClick={closeResetCampaignDataform} variant="outlined" >
                                                    Cancel
                                                </Button>
                                            </Grid>
                                            <Grid item >
                                                <Button style={formButtonStyle} type="submit" variant="contained" form="resetCampaign-Form" >
                                                    Preview Data
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>}

                                {openDownloadDataGrid && (
                                    <>
                                        {newLoading && (
                                            <div style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: '0,0,0,0.5', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
                                                <LoadingScreen />
                                            </div>
                                        )}
                                        <div style={{ minWidth: '1150px' }}>
                                            <Grid container spacing={2} direction={'row'} flexGrow={1} sx={{ marginTop: 1 }} alignItems="center" justifyContent='space-between' >
                                                <div onClick={closeDataGrid} style={{ marginLeft: '15px', marginBottom: '-25px' }} >
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/icons/backIcon.svg`}
                                                        alt="Back"
                                                    ></img>
                                                    <Button variant='text' style={{ color: "#536580" }}>Back</Button>
                                                </div>
                                                <Grid item xs={12} my={2}>
                                                    <OZTable
                                                        columns={columns}
                                                        rows={rowData}
                                                        component={Card}
                                                        totalRows={totalRows}
                                                        onRowsChangeEvent={handleChangeRowsPerPage}
                                                        pagination={totalRows > 0}
                                                        onPageChangeEvent={handlePageChange}
                                                        pageController={controller}
                                                        totalCount={totalPages}
                                                    ></OZTable>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2} direction={'row'} flexGrow={1} flex sx={{ paddingBottom: '15px' }} alignItems="center" justifyContent='space-between'>
                                                <Grid item>
                                                    {rowData && rowData?.length > 0 ? <img style={{ cursor: 'pointer' }} onClick={() => handleDelete(props.values)} src={`${process.env.PUBLIC_URL}/icons/deleteicon.svg`} alt='remove2'></img> : null}
                                                </Grid>
                                                <Grid item>
                                                    <Button style={formButtonStyle} onClick={closeResetCampaignDataform} variant="outlined" >
                                                        Cancel
                                                    </Button>
                                                    <Button style={{ ...formButtonStyle, marginLeft: "20px" }} onClick={() => handleReset(props.values)} variant="contained">
                                                        Reset
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </>
                                )}
                            </div>
                        </form>
                    )}
                </Formik>

            </div>
        );
    };
    return (
        <div>
            <OZDialog
                hideActions
                title={
                    <label style={{ fontSize: '1.125rem', color: '#000000', fontWeight: '400' }}>
                        Reset Campaign
                    </label>
                }
                open={openResetCampaignDataform}
                onClose={closeResetCampaignDataform}
            >
                <Divider style={{ color: "#E6E5E6" }}></Divider>
                {<DataForm data={props?.props} />}
            </OZDialog>
        </div>
    );
};

export default ResetCampaignForm;
